import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function AgencyCreateMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.drc.salesOrderManagement.batchReceiveDrc);
  };

  return (
    <MainMenuItem
      itemTitleString="受発注管理"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default AgencyCreateMenuItem;
